export default "__VITE_ASSET__An8MfgU0__"